"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dialog = require("@reach/dialog");

var _classnames = _interopRequireDefault(require("classnames"));

require("@reach/dialog/styles.css");

var _DarkButton = _interopRequireDefault(require("../Button/DarkButton"));

var _IconClose = _interopRequireDefault(require("../Icons/IconClose"));

var _Dialog = _interopRequireDefault(require("./Dialog.style"));

function CloseIconButton(_ref) {
  var onClick = _ref.onClick;
  return _react.default.createElement(_DarkButton.default.IconButton, {
    onClick: onClick,
    className: (0, _classnames.default)('close-dialog-button', _Dialog.default.closeDialogButton)
  }, _react.default.createElement(_IconClose.default, {
    className: (0, _classnames.default)('close-dialog-button-icon', _Dialog.default.closeDialogButtonIcon)
  }));
}

function Dialog(props) {
  var close = props.close,
      showDialog = props.showDialog,
      children = props.children,
      showCloseButton = props.showCloseButton,
      className = props.className;
  return _react.default.createElement(_dialog.DialogOverlay, {
    className: (0, _classnames.default)('dialog-overlay', className),
    isOpen: showDialog,
    onDismiss: close
  }, _react.default.createElement(_dialog.DialogContent, {
    className: (0, _classnames.default)('dialog-content', _Dialog.default.dialogContent)
  }, showCloseButton ? _react.default.createElement(CloseIconButton, {
    onClick: close
  }) : null, children));
}

Dialog.defaultProps = {
  showCloseButton: false,
  close: function close() {
    return null;
  },
  showDialog: false,
  className: ''
};
Dialog.propTypes = {
  showCloseButton: _propTypes.default.bool,
  close: _propTypes.default.func,
  showDialog: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = Dialog;
exports.default = _default;